import React, { useEffect, useState } from 'react';
import { ColumnProps } from 'antd/lib/table';

import {
  Approval,
  ApprovalRequest,
  ApprovalRequests,
} from '@totem/components/ticketing/ticketing';
import IBTable from '@totem/components/ui_components/antDesignOverrides/IBTable';
import { formatDate, isNotNull } from '@totem/utilities/common';
import { sortStringAscending } from '@totem/utilities/tableUtilities';

interface ApprovalItem {
  approvalRequest: ApprovalRequest;
  approval: Approval;
}

type Props = {
  approvalRequests: ApprovalRequests;
};

const ApprovalReport = ({ approvalRequests }: Props) => {
  const [approvalItems, setApprovalItems] = useState<ApprovalItem[]>([]);

  useEffect(() => {
    const newApprovalItems: ApprovalItem[] = [];
    if (isNotNull(approvalRequests)) {
      approvalRequests.forEach((request) => {
        request.approvalGroup.approvals.forEach((approval) => {
          newApprovalItems.push({
            approvalRequest: request,
            approval,
          });
        });
      });
    }

    setApprovalItems(newApprovalItems);
  }, approvalRequests);

  const columns: ColumnProps<ApprovalItem>[] = [
    {
      title: 'Request Summary',
      dataIndex: 'summary',
      key: 'approvalRequest.summary',
      render: (_, record: ApprovalItem) => (
        <span>{record.approvalRequest.summary}</span>
      ),
      showSorterTooltip: true,
      sortDirections: ['ascend', 'descend'],
      sorter: (compA, compB) =>
        sortStringAscending(
          compA.approvalRequest.summary,
          compB.approvalRequest.summary,
        ),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'approval.status',
      render: (_, record: ApprovalItem) => (
        <span>{record.approval.status}</span>
      ),
      showSorterTooltip: true,
      sortDirections: ['ascend', 'descend'],
      sorter: (compA, compB) =>
        sortStringAscending(compA.approval.status, compB.approval.status),
    },
    {
      title: 'Approver',
      dataIndex: 'status',
      key: 'approval.approverEmail',
      render: (_, record: ApprovalItem) => (
        <span>{record.approval.approverEmail}</span>
      ),
      showSorterTooltip: true,
      sortDirections: ['ascend', 'descend'],
      sorter: (compA, compB) =>
        sortStringAscending(
          compA.approval.approverEmail,
          compB.approval.approverEmail,
        ),
    },
    {
      title: 'Created At',
      dataIndex: 'approvalRequest.createdAt',
      key: 'approvalRequest.createdAt',
      render: (_, record: ApprovalItem) => (
        <span>{formatDate(record.approvalRequest.createdAt)}</span>
      ),
      showSorterTooltip: true,
      sortDirections: ['ascend', 'descend'],
      sorter: (compA, compB) =>
        sortStringAscending(
          compA.approvalRequest.createdAt,
          compB.approvalRequest.createdAt,
        ),
    },
    {
      title: 'Outcome At',
      dataIndex: 'approval.outcomeAt',
      key: 'approval.outcomeAt',
      render: (_, record: ApprovalItem) => (
        <span>{formatDate(record.approval.outcomeAt)}</span>
      ),
      showSorterTooltip: true,
      sortDirections: ['ascend', 'descend'],
      sorter: (compA, compB) =>
        sortStringAscending(compA.approval.outcomeAt, compB.approval.outcomeAt),
    },
  ];

  return (
    <IBTable
      showSorterTooltip
      columns={columns}
      dataSource={approvalItems}
      loading={false}
      rowKey={(record) => record.approval.id}
    />
  );
};

export default ApprovalReport;
